var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.759,
    height: 20.761,
    viewBox: "0 0 20.759 20.761",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102",
    transform: "translate(-328.121 -456)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(328.121 458.611)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M9.3,19a3.681,3.681,0,0,1-3.676-3.676V3.019l-4.179.957A1.946,1.946,0,0,0,.065,6.354L3.648,19.731a1.965,1.965,0,0,0,1.886,1.438,1.9,1.9,0,0,0,.484-.062L14.735,19Z",
    transform: "translate(0 -3.019)",
    fill: "#2ace82"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    transform: "translate(335.04 456)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M12.73,8.46A1.73,1.73,0,1,0,11,6.73,1.732,1.732,0,0,0,12.73,8.46Z",
    transform: "translate(-8.405 -0.675)",
    fill: "#2ace82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M21.839,2.595A2.6,2.6,0,0,0,19.244,0h-8.65A2.6,2.6,0,0,0,8,2.595V14.7A2.6,2.6,0,0,0,10.595,17.3h8.65A2.6,2.6,0,0,0,21.839,14.7ZM10.595,1.73h8.65a.865.865,0,0,1,.865.865V8.164l-.657-.657a1.517,1.517,0,0,0-2.145,0L13.19,11.624l-1.09-1.09a1.517,1.517,0,0,0-2.145,0l-.225.225V2.595A.865.865,0,0,1,10.595,1.73Z",
    transform: "translate(-8)",
    fill: "#2ace82"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.644d955d0cdbea6ec7f494174a772f0d.svg";
export { ForwardRef as ReactComponent };